<template>
  <section :id="id ? id : false" class="marketplace-table">
    <slot name="header"></slot>
    <div
      v-if="shouldDisplayOrderDetails"
      class="marketplace-table--order-details--wrapper p-md"
    >
      <div v-if="$slots['order-details-col-1']" class="marketplace-table--order-details--col">
        <slot name="order-details-col-1"></slot>
      </div>
      <div v-if="$slots['order-details-col-2']" class="marketplace-table--order-details--col">
        <slot name="order-details-col-2"></slot>
      </div>
      <div v-if="$slots['order-details-col-3']" class="marketplace-table--order-details--col">
        <slot name="order-details-col-3"></slot>
      </div>
      <div v-if="$slots['order-details-col-4']" class="marketplace-table--order-details--col">
        <slot name="order-details-col-4"></slot>
      </div>
    </div>
    <div class="marketplace-table--body p-md">
      <slot name="body"></slot>
    </div>
    <slot name="customer-return"></slot>
    <slot name="footer"></slot>
  </section>
</template>

<script>
export default {
  name: 'MarketplaceTable',
  props: {
    id: {type: String|Number, default: ''}
  },
  computed: {
    shouldDisplayOrderDetails() {
      return this.$slots['order-details-col-1']
        || this.$slots['order-details-col-2']
        || this.$slots['order-details-col-3']
        || this.$slots['order-details-col-4'];
    }
  }
};
</script>

<style lang="scss">
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace-table {
  margin-bottom: 3rem;
  border: 1px solid $color-gray-400;
  border-radius: 1.2rem;

  &--body, &--body > div {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    row-gap: 1.6rem;
  }

  &--order-details--wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 1.6rem;
    border-bottom: 1px solid $color-gray-400;

    @media (min-width: $screen-sm) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: $screen-lg) {
      grid-template-columns: repeat(4, 1fr);
    }

    @media print {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &--order-details--col {
    h4 {
      margin-top: 0;
      font-size: 1.6rem;
      font-weight: 500;
    }

    p {
      margin: 0;
      color: $color-gray-800;
      word-break: break-word;

      &.customer-po-number {
        word-break: break-all;
      }
    }

    :deep(.slo-icon.size-lg) {
      width: 24px !important;
      height: 24px !important;
    }
  }
}
</style>
